export default "__VITE_ASSET__BtLR6OiZ__"